import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImagesService {

  // ICONS PATH
  appLogo = 'icons/app-logo.svg';
  dashboardIconBlack = 'icons/dashboard.svg';
  dashboardIconWhite = "icons/dashboard-white.svg";
  transactionIconWhite = 'icons/transactions-white.svg';
  transactionIconBlack = "icons/transactions-black.svg";
  recordsIconBlack = 'icons/records-black.svg';
  recordsiconWhite = "icons/records-white.svg";
  systemIconBlack = 'icons/system-black.svg';
  systemIconWhite = "icons/system-white.svg";
  settingsIconBlack = 'icons/settings.svg';
  settingsIconWhite = 'icons/settings-white.svg';
  notificationIconBlack = 'icons/notification.svg';
  calenderMonthIcon = 'icons/calendar_month.svg';
  arrowDropDownIcon = 'icons/arrow_drop_down.svg';
  bagIcon = 'icons/bag.svg';
  sellIcon = 'icons/sell.svg';
  shareIcon = 'icons/share.svg';
  overdueIcon = 'icons/overdue.svg';
  downloadIcon = "icons/download.svg";
  excelIcon = "icons/excel.svg";
  pdfIcon = "icons/pdf.svg";
  productIcon = "icons/product.svg";
  statusIcon = "icons/status.svg";
  personIcon = 'icons/person.svg';
  passwordCloseIcon = 'icons/password-close.svg';
  arrowDwon = "icons/arrow-down.svg";
  selectOptionIcon = "icons/select-icon.svg";
  arrowRightNorth = "icons/arrow-right-north.svg";
  arrowRightSouth = "icons/arrow-right-south.svg";
  addIconWhite = "icons/add-icon.svg";
  csvIcon = "icons/csv.svg";
  searchIcon = "icons/search.svg";
  filterIcon = "icons/filter.svg";
  arrorOutward ="icons/arrow-outward.svg";
  closeIcon = "icons/close.svg";
  product2Icon = "icons/product2.svg";
  arrowRight = "icons/arrow-right.svg";
  amountIcon = "icons/amountIcon.svg";
  creditIcon = "icons/credit.svg";
  personRound = "icons/person-round.svg";
  requestIcon = "icons/request.svg";
  loanIcon = "icons/loan.svg";
  editIcon = 'icons/edit.svg';
  editRoundIcon = "icons/edit-round.svg";
  menuIcon = "icons/menu.svg";
  downloadColored = "icons/download-colored.svg";
  deleteIcon = "icons/delete.svg";
  addIcon = "icons/add.svg";
  arrowForward = "icons/arrow-forward.svg";
  checkIcon = "icons/check.png";
  deniedIcon = "icons/denied.svg";
  approvedIcon = "icons/approved.svg";
  pendingIcon = "icons/pending.svg";
  visible= "icons/visibility.png";
  unvisible = "icons/unvisible.png"
  noProductPlaceholder = "icons/no-product-placeholder.svg";


  // IMAGES PATH
  img1 = 'images/img1.png';
  img2 = 'images/img2.png';
  imgDashboard = 'images/img-dashboard.jpg';

  profilePlaceholder = 'dummy/profile.svg';
}
